import { render } from "./DropdownMenuItem.vue?vue&type=template&id=42a36cc4&scoped=true"
import script from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenuItem.vue?vue&type=style&index=0&id=42a36cc4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a36cc4"],['__file',"src/components/UI/DropdownMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42a36cc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42a36cc4', __exports__)) {
    api.reload('42a36cc4', __exports__)
  }
  
  module.hot.accept("./DropdownMenuItem.vue?vue&type=template&id=42a36cc4&scoped=true", () => {
    api.rerender('42a36cc4', render)
  })

}


export default __exports__